import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Rating = () => {
  return(
    <SettingsMetaData propertyName={"AgentRating"} viewPropertyName={"Agent Rating"} />
  )
};

export default Rating;
